import FieldDate from './classes/FieldDate';
import FieldFile from './classes/FieldFile';
import ProductFieldsLoader from './classes/ProductFieldsLoader';
import PriceManager from './pricing/PriceManager';
import PriceFormatter from './pricing/PriceFormatter';
import TotalsElementWatcher from './classes/TotalsElementWatcher';

jQuery(() => {
	if (typeof fpf_pro_front === 'undefined') {
		console.error('Required global fpf_pro_front is not defined');
		return;
	}

	const priceFormatter = new PriceFormatter(
		fpf_product.currency_format_num_decimals,
		fpf_product.currency_format_symbol,
		fpf_product.currency_format_decimal_sep,
		fpf_product.currency_format_thousand_sep,
		fpf_product.currency_format
	);

	const priceManager = new PriceManager(
		priceFormatter,
		parseFloat(fpf_product.fpf_product_price)
	);

	const init = () => {
		// Fields initialization.
		new FieldDate();
		new FieldFile();

		priceManager.init(fpf_product.fpf_fields);
		priceManager.initCalculatorState();

		// Conditional logic.
		jQuery('select.fpf-input-field, input.fpf-input-field').change();
	};

	// Re-run initialization on fields ready event.
	jQuery(document).on('fpf_fields_ready', init);

	// Fields loader for product variations (ajax).
	new ProductFieldsLoader();

	if (document.querySelector('#fpf_totals')) {
		init();
		return;
	}

	// Otherwise start DOM watcher for lazy-loaded content (some custom themes)
	const totalsElementWatcher = new TotalsElementWatcher(init);
	totalsElementWatcher.startWatching();
});
